import { FlowType } from "@/features/payment-form/model/types";
import { PaymentForm } from "@/features/payment-form/ui";

export const RenewSubscriptionPage = () => {
  return <PaymentForm flowType={FlowType.RENEW_SUBSCRIPTION} />;
};
